import { useEffect, useRef } from 'react';
import { getSegmentGroup, SegmentGroup } from '@fxtr/i18n';

export const POLL_INTERVAL_MS = 3000;
export const MODES = { create: 'CREATE', update: 'UPDATE' };
export const FINISHED_STATUSES = ['COMPLETED', 'COMPLETED_WITH_ERRORS', 'FAILED'];

/** Garage imports are for partner segments only; Fixter segments get null. */
export function importSegment(segment) {
  try {
    if (!segment) return null;
    const group = getSegmentGroup(segment);
    return group === SegmentGroup.MOTRIO || group === SegmentGroup.RENAULT ? segment : null;
  } catch {
    return null;
  }
}

/** Whole-number percentage of rows done, 0 when there is nothing to import. */
export function progressPercent(progress) {
  const total = (progress && progress.total - progress.invalid) || 0;
  if (total <= 0) return 0;
  return Math.min(100, Math.floor((progress.done / total) * 100));
}

/**
 * Calls load every intervalMs while active is true, waiting for each call to
 * finish before scheduling the next. Stops on unmount or when active turns false.
 */
export function usePolling(load, active, intervalMs = POLL_INTERVAL_MS) {
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    let timer;
    const tick = async () => {
      await loadRef.current();
      if (!cancelled) timer = setTimeout(tick, intervalMs);
    };
    timer = setTimeout(tick, intervalMs);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [active, intervalMs]);
}
